import enMessages from "../locales/en.json";

const EnLang = {
  messages: {
    ...enMessages,
  },
  locale: "en",
};
export default EnLang;
